/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import { ensureBusinessDay, permittedDate } from '@helpers/date';
import addBusinessDays from 'date-fns/addBusinessDays';
import addYears from 'date-fns/addYears';
import isBefore from 'date-fns/isBefore';
import isEqual from 'date-fns/isEqual';
import S from './DatePicker.styles';
const Datepicker = (props) => {
    const [start, setStart] = useState(ensureBusinessDay(props.startDate, props.excludedDates));
    const [end, setEnd] = useState(props.endDate ? ensureBusinessDay(props.endDate, props.excludedDates) : null);
    const containerRef = useRef(null);
    const minDate = useMemo(() => {
        if (props.leadTimeDays === undefined) {
            return addYears(new Date(), -5);
        }
        if (props.leadTimeDays === 0) {
            return new Date();
        }
        const minDate = addBusinessDays(new Date(), props.leadTimeDays);
        return ensureBusinessDay(minDate, props.excludedDates);
    }, [props.leadTimeDays]);
    const handleChange = (dates) => {
        let start = null, end = null;
        if (Array.isArray(dates)) {
            [start, end] = dates;
        }
        else {
            start = dates;
        }
        if (props.selectsEnd) {
            if (end !== null) {
                setStart(start);
                setEnd(end);
            }
            else {
                setEnd(start);
            }
            return;
        }
        setStart(start);
        setEnd(end);
    };
    useEffect(() => {
        if (start !== null && !isEqual(props.startDate, start)) {
            props.onStartDateChanged(start);
        }
        if (props.endDate !== undefined &&
            props.onEndDateChanged !== undefined &&
            end !== null &&
            !isEqual(props.endDate, end)) {
            props.onEndDateChanged(end);
            /**
             * When new start date is selected, default end date to equal it
             */
        }
        else if (end === null && start !== null && props.onEndDateChanged !== undefined) {
            props.onEndDateChanged(start);
        }
    }, [start, end]);
    const filterDate = (date) => {
        const day = date.getDay();
        const isWeekend = day === 0 || day === 6;
        if (isWeekend) {
            return false;
        }
        if (props.selectsEnd === true && props.startDate !== null) {
            return !isBefore(date, props.startDate);
        }
        if (props.excludedDates) {
            return permittedDate(date, props.excludedDates);
        }
        return true;
    };
    return (React.createElement(S.Wrapper, { ref: containerRef },
        React.createElement(S.LabelText, null, props.label),
        React.createElement(S.PickerWrapper, null,
            React.createElement(DatePicker, { dateFormat: 'MMM d, yyyy', selectsRange: props.endDate !== undefined && props.onEndDateChanged !== undefined, startDate: start, endDate: end, minDate: minDate, selectsEnd: props.selectsEnd, onChange: handleChange, filterDate: filterDate, inline: true, maxDate: addYears(new Date(), 5), selected: start }))));
};
export default Datepicker;
